import './FlattenLessonStandardList.scss';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

const defaultProps = {
  standards: [],
};

export default function FlattenLessonStandardList(props) {
  const { standards } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div>
      <ul className='flatten-standard-list' data-test='standard-list'>
        {
          standards.map((standard) => (
            <li key={`lesson-standard-${standard.id}`} data-test={`lesson-standard-${standard.id}`}>
              <div className='standard-code' data-test='standard-code'>
                {standard.attributes.standardCode}
              </div>
              <div className='standard-description' data-test='standard-description'>
                {standard.attributes.standardDescription}
              </div>
            </li>

          ))
        }
      </ul>
    </div>
  );
}
